module.exports = __webpack_public_path__ + "img/定制人群获取关闭.54a05bbe.svg";